import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { AlertasService } from '../core/_services/alerta.service';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-fichas',
  templateUrl: './fichas.component.html',
  styleUrls: ['./fichas.component.scss']
})
export class FichasComponent implements OnInit {

  @Input() fichaActual: any;


  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
  }

  //Variables Conocimientos Especificos
  registrosListaConocimientos: any;
  registrosConocimientos: any = [];
  listaDisponiblesConocimientos: any[] = [];
  listaAsignadosOrigConocimientos: any[] = [];
  listaCategoriasConocimientos: any[] = [];
  listaAsignadosConocimientos: any[] = [];

  //Variables Competencias 
  listaAsignadosCompetencias: any[] = [];
  listaDisponiblesCompetencias: any[] = [];

  //Variables Habilidades 
  listaAsignadosHabilidades: any[] = [];
  listaDisponiblesHabilidades: any[] = [];

  listaAsignadosFormacionReq: any[] = [];
  listaDisponiblesFormacionReq: any[] = [];

  listaAsignadosProfesiones: any[] = [];
  listaDisponiblesProfesiones: any[] = [];

  ngOnInit(): void {
    // this.fichaActual = this.route.snapshot.paramMap.get('id');


    this.getListaConocimientos();
    this.getListaConocimientosAsignados();
    this.getListaCompetenciasDisponibles();
    this.getListaHabilidadesDisponibles();
    this.getListaAsignadosFormacion();
    this.getListaAsignadosAreaExpe();
    this.getListaProfesiones();

  }


  guardarCompetencias() {
    let registros = [];


    this.listaAsignadosCompetencias.forEach(e => {
      registros.push(e);
    });

    let params = {
      registros: registros,
      fichaActual: this.fichaActual,
      titulo: 'Competencias'
    }
    this.coreService.post('/guardar-ficha-otros-aspectos', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
      }
    )
  }

  /**
     * filtro
     */
  filtradoConocimientos(evento) {

    if (evento.value.length == 0) {
      this.listaDisponiblesConocimientos = this.listaAsignadosOrigConocimientos;
    } else {
      this.listaDisponiblesConocimientos = this.listaAsignadosOrigConocimientos.filter(opcion => evento.value.find(seleccionado => seleccionado.cod_tip_referencia == opcion.cod_tip_referencia))
    }

  }

  guardarConocimientos() {
    let registros = [];

    this.listaAsignadosConocimientos.forEach(e => {
      registros.push(e);
    });


    let params = {
      registros: registros,
      fichaActual: this.fichaActual,
      titulo: 'Conocimientos Especificos'
    }
    this.coreService.post('/guardar-ficha-otros-aspectos', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
      }
    )
  }

  guardarHabilidades() {
    let registros = [];

    this.listaAsignadosHabilidades.forEach(e => {
      registros.push(e);
    });

    let params = {
      registros: registros,
      fichaActual: this.fichaActual,
      titulo: 'Habilidades'
    }
    this.coreService.post('/guardar-ficha-otros-aspectos', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
        this.msj.error('Registro No Guardado Correctamente');

      }
    )
  }


  /**
   * listados Conocimientos Especificos
   */
  getListaConocimientos() {
    this.coreService.get('/listas/cargosConocimientosEspecificos').subscribe(
      (res: any) => {
        this.listaCategoriasConocimientos = res;
      },
      (err: any) => {
      }
    )
  }

  getListaConocimientosAsignados() {

    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-ficha-conocimientos', params).subscribe(
      (res: any) => {
        this.listaAsignadosOrigConocimientos = res.listaTotal;
        this.listaAsignadosConocimientos = res.listaFichaActual;

        let disponibles = res.listaTotal;

        this.listaAsignadosConocimientos.forEach((item, index) => {
          disponibles = disponibles.filter(function (dispo) {
            return dispo.id !== item.id;
          });
        });
        this.listaDisponiblesConocimientos = disponibles;

      },
      (err: any) => {
      }
    )
  }

  /**
  * listados Competencias
  */
  getListaCompetenciasDisponibles() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-ficha-competencias', params).subscribe(
      (res: any) => {
        this.listaAsignadosCompetencias = res.listaFichaActual;
        let disponibles = res.listaTotal;

        this.listaAsignadosCompetencias.forEach((item, index) => {
          disponibles = disponibles.filter(function (dispo) {
            return dispo.id !== item.id;
          });
        });
        this.listaDisponiblesCompetencias = disponibles;

      },
      (err: any) => {
      }
    )
  }
  /**
  * listados Habilidades
  */
  getListaHabilidadesDisponibles() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-ficha-habilidades', params).subscribe(
      (res: any) => {
        this.listaAsignadosHabilidades = res.listaFichaActual;
        let disponibles = res.listaTotal;
        this.listaAsignadosHabilidades.forEach((item, index) => {
          disponibles = disponibles.filter(function (dispo) {
            return dispo.id !== item.id;
          });
        });
        this.listaDisponiblesHabilidades = disponibles;
      },
      (err: any) => {
      }
    )
  }

  getListaAsignadosFormacion() {

    let params = {
      fichaActual: this.fichaActual
    };

    this.coreService.getWithParams('/index-formacion-requerida', params).subscribe(
      (res: any) => {

        this.listaAsignadosFormacionReq = res.listaFichaActual;
        const disponibles = res.listaTotal;
        let disponiblesFiltradas: any[] = res.listaTotal;
        disponibles.forEach((item) => {
          this.listaAsignadosFormacionReq.forEach((i) => {
            if (i.des_referencia == item.des_referencia) {
              disponiblesFiltradas = disponiblesFiltradas.filter(indice => indice.id != i.id);
            }
          })
        });
        this.listaDisponiblesFormacionReq = disponiblesFiltradas;
      },
      (err: any) => {
      }
    )
  }
  /**
  * guardar formación requerida
  */
  guardarFormacionRequerida() {
    let registros = [];
    this.listaAsignadosFormacionReq.forEach(e => {
      registros.push(e.id);
    });
    let params = {
      ficha_id: this.fichaActual,
      registros: registros
    }
    this.coreService.post('/guardar-formacion-requerida', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
      }
    )
  }




  listaAsignadosAreasExpe: any[] = [];
  listaDisponiblesAreasExpe: any[] = [];

  getListaAsignadosAreaExpe() {
    let params = {
      fichaActual: this.fichaActual
    };

    this.coreService.getWithParams('/index-ficha-area-experiencia', params).subscribe(
      (res: any) => {
        this.listaAsignadosAreasExpe = res.listaFichaActual;
        const disponibles = res.listaTotal;
        let disponiblesFiltradas: any[] = res.listaTotal;
        disponibles.forEach((item) => {
          this.listaAsignadosAreasExpe.forEach((i) => {
            if (i.des_referencia == item.des_referencia) {
              disponiblesFiltradas = disponiblesFiltradas.filter(indice => indice.id != i.id);
            }
          })
        });
        this.listaDisponiblesAreasExpe = disponiblesFiltradas;
      },
      (err: any) => {
      }
    )
  }

  guardarAreaExpe() {
    let registros = [];
    this.listaAsignadosAreasExpe.forEach(e => {
      registros.push(e.id);
    });
    //FIXME: corregir id de la ficha
    let params = {
      ficha_id: this.fichaActual,
      registros: registros
    }
    this.coreService.post('/guardar-ficha-area-experiencia', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
      }
    )
  }




  getListaProfesiones() {

    let params = {
      fichaActual: this.fichaActual
    };

    this.coreService.getWithParams('/index-ficha-profesiones', params).subscribe(
      (res: any) => {

        this.listaAsignadosProfesiones = res.listaFichaActual;
        const disponibles = res.listaTotal;
        let disponiblesFiltradas: any[] = res.listaTotal;
        disponibles.forEach((item) => {
          this.listaAsignadosProfesiones.forEach((i) => {
            if (i.des_referencia == item.des_referencia) {
              disponiblesFiltradas = disponiblesFiltradas.filter(indice => indice.id != i.id);
            }
          })
        });
        this.listaDisponiblesProfesiones = disponiblesFiltradas;
      },
      (err: any) => {
      }
    )

  }

  guardarProfesion() {
    let registros = [];
    this.listaAsignadosProfesiones.forEach(e => {
      registros.push(e.id);
    });

    let params = {
      ficha_id: this.fichaActual,
      registros: registros
    }
    this.coreService.post('/guardar-ficha-profesion', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
      }
    )
  }

}
